
// volunteer
//------------------------------------------------------------
$(function(){
    if( $("body").is("#volunteer") ){
        $(".vl_bigimg").on('tap', function(){
            $(".vl_bigimg_wrap").toggleClass('active');
        });
    }
});


// WEBPACK FOOTER //
// ./_src/js/cont/volunteer.js